package floris.graphics.models.dto.requests.contributor

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InsertOrUpdateContributor(
    val name: String = "",
    val website: String? = null,
    val bio: String? = null,
) {
    val isValid get() = name.isNotBlank()
}
